// ------------- import external dependencies -------------
import { useMutation, useQuery } from "@tanstack/react-query";

// ------------ import internal dependencies -------------
import {
  getProfiles,
  getRoles,
  deleteAssignment,
  addNewFacilityAssignment,
} from "../api/assignmment";
import { getUserFacilities } from "../api/user";

interface Props {
  profileId?: string;
  userId?: string;
}

function useAssignment({ profileId, userId }: Props = {}) {
  const getSystemFacilities = useQuery(
    ["facilities"],
    () => getUserFacilities(userId as string),
    {
      enabled: !!userId,
    }
  );

  const getSystemRoles = useQuery(
    ["roles", profileId],
    () => getRoles(profileId as string),
    {
      enabled: !!profileId,
    }
  );

  const getSystemProfiles = useQuery(["profiles"], () => getProfiles());

  const deleteUserAssignment = useMutation((req: any) => deleteAssignment(req));

  /**
   * Add new assignment to a user in a facility
   */
  const addUserAssignment = useMutation((req: any) =>
    addNewFacilityAssignment(req)
  );

  return {
    getSystemFacilities,
    getSystemRoles,
    getSystemProfiles,
    deleteUserAssignment,
    addUserAssignment,
  };
}

export default useAssignment;
